import {useEffect} from 'react';
import { Grid, Tooltip,IconButton, Chip,Typography } from "@material-ui/core";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SettingsIcon from '@material-ui/icons/Settings';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import {makeStyles } from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import { useHistory,useLocation } from "react-router-dom";
import * as userActions from '../../actions/authenticationActions';
import * as briefActions from '../../actions/briefActions';
import {HEADER_TEXTS} from '../../utility';
import {useSelector} from 'react-redux';
import isEmpty from "lodash/isEmpty";


const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: theme.palette.common.white,
    },
    tooltip: {
      backgroundColor: theme.palette.primary.main,
    },
  }));

const useStyles = makeStyles((theme) => ({
    root: {
      transform: 'translateZ(0px)',
      flexGrow: 1,
    },
    exampleWrapper: {
      position: 'relative',
      marginTop: theme.spacing(3),
      height: 380,
    },
    radioGroup: {
      margin: theme.spacing(1, 0),
    },
    speedDial: {
      position: 'absolute',
      '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
        bottom: theme.spacing(2),
        right: theme.spacing(2),
      },
      '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
        top: theme.spacing(2),
        left: theme.spacing(2),
      },
    },
}));


function DashboardHeader(props){
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const loggedInState = useSelector(state => state.auth);
    const currentPage = useSelector(state => state.currentPage);
    const [isLoadingSites, setIsLoadingSites] = React.useState(false);
    const actions = [
        { icon: <AccountCircleIcon />, name: (props.Briefs.users) ? props.Briefs.users[0][1] : null },
        { icon: <ExitToAppIcon />, name: 'Logout' },
      ];
    const Logout = ()=>{
        dispatch(userActions.logoutUser());
        history.push('/login_adthrive');
    }

    // fetch all sites if needed in order to determine
    // whether or not to show site selection ui
    useEffect(() => {
      if(isLoadingSites){
        return;
      } else if(loggedInState.isLoggedInAdthrive && isEmpty(loggedInState.adthriveSites)){
        // fetch all sites
        setIsLoadingSites(true);
        dispatch(userActions.fetchAdthriveSites(() => {
          setIsLoadingSites(false);
        }));
      }
    });

    const DashboardView = () => {
      // Remove PreviousURL logic upon back button
      let previousURLObject = (localStorage.previousURLObject && JSON.parse(localStorage.previousURLObject))? JSON.parse(localStorage.previousURLObject) : {};
      if (previousURLObject[currentPage.postId]){
        delete previousURLObject[currentPage.postId];
        localStorage.setItem("previousURLObject", JSON.stringify(previousURLObject));
      }
      if(loggedInState.isLoggedInAdthrive){
        history.push('/dashboard_adthrive');
      } else if(loggedInState.isLoggedIn){
        history.push('/dashboard_legacy');
      } else{
        history.push('/login_adthrive')
      }
      
      dispatch(briefActions.setActiveBrief({}));
    }

    const handleSwitchSite = () => {
      dispatch(userActions.setActiveSite());
      history.push('/choose_site');
    }

    var activeSite = loggedInState.activeSite;
    var infoText;
    if(loggedInState.isLoggedInAdthrive){
      infoText = `Logged in (${activeSite ? activeSite.name : 'AdThrive'})`;
    } else if(loggedInState.isLoggedIn){
      infoText = 'Logged in (legacy)';
    } else{
      infoText = 'Not logged in';
    }

    

    return(
        <Grid container xs="12" md="12" direction="row" alignItems="center" style={{padding:'0',textAlign:'center',background:'rgb(249, 249, 249)'}}>
          {(props.goBack)?
            <Grid item direction="row" xs='3'>
                <Tooltip title={HEADER_TEXTS.BACK_BUTTON_LABEL} arrow classes={useStylesBootstrap()} style={{marginLeft:'0.5rem', padding: '10px'}}>
                    <IconButton  aria-label="Back" onClick={DashboardView}>
                        <KeyboardBackspaceIcon color="primary" style={{color: '#859fbd'}} />
                    </IconButton>
                </Tooltip>
            </Grid>: null}
            <Grid item direction="row" xs={(props.goBack)? "6" : "9"} style={{padding:'0.7rem 0rem'}}>
              {(!props.TopicName && !props.goBack) ? 
                <div>
                  <Typography variant="subtitle2" color="primary" style={{textAlign: 'left', marginLeft: '20px', color: '#859fbd', float:'left'}}>
                    {infoText}
                  </Typography>
                  {!isEmpty(activeSite) && loggedInState && loggedInState.adthriveSites && loggedInState.adthriveSites.length > 1 && <Tooltip title="Switch Site">
                      <SettingsIcon fontSize="small" style={{color: '#859fbd', cursor: 'pointer', float: 'left', marginLeft: '7px', opacity: '0.8'}} onClick={handleSwitchSite}></SettingsIcon>
                    </Tooltip>}
                </div>
                : 
                <Typography variant="subtitle2" color="primary" style={{fontSize: '12px', fontWeight: 'bold', color: '#9ca2aa'}}>
                  {props.TopicName}
                </Typography>}
            </Grid>
            <Grid item direction="row" xs='3'>
              {(props.isNotLoggedIn)? null : 
                <div style={{color: '#859fbd', cursor: 'pointer'}} aria-label="Logout" onClick={Logout}>Log Out</div>
                }
            </Grid>
        </Grid>
    );

}

export default DashboardHeader;